export default function processesDirective() {
  return {
    template: require('./processes.html'),
    scope: {
      customerId: '<',
      department: '=',
      isEdit: '<',
      showTitle: '<',
      isIt: '='
    },
    controller: 'ProcessesController',
    controllerAs: 'processesVM',
    bindToController: true,
    replace: true,
  };
}
